import { render, staticRenderFns } from "./brandSet.vue?vue&type=template&id=98567ce4&scoped=true&"
import script from "./brandSet.vue?vue&type=script&lang=js&"
export * from "./brandSet.vue?vue&type=script&lang=js&"
import style0 from "./brandSet.vue?vue&type=style&index=0&id=98567ce4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98567ce4",
  null
  
)

export default component.exports